
import { BaseOauthClient, OauthConfig } from "./base";
import { AirtableOauthClient } from "./airtable";
import { GoogleSheetsOauthClient } from "./google_sheets";

export const OauthClients: { [key: string]: typeof BaseOauthClient } = {
    airtable: AirtableOauthClient,
    google_sheets: GoogleSheetsOauthClient
}

export {
    BaseOauthClient,
    AirtableOauthClient,
    GoogleSheetsOauthClient
};
export type { OauthConfig };
